module.exports = __webpack_public_path__ + "static/media/asmatask.76b6e5c6.png";